import { Route, Switch, useRouteMatch } from 'react-router-dom';
import CARRequest from './Request/Request';
import CARApprove from './Approve/Approve';

const ComputerAdminRights = () => {
	const { path } = useRouteMatch();
	return (
		<Switch>
			<Route
				path={`${path}/Approve`}
				exact
				render={props => (
					<CARApprove querystring={props.location.search} />
				)}
			/>
			<Route
				path={`${path}/Request`}
				exact
				render={props => (
					<CARRequest querystring={props.location.search} />
				)}
			/>
			<Route path='*'>404...</Route>
		</Switch>
	);
};
export default ComputerAdminRights;
